// export const API_URL = "http://localhost:3000/user-data";
export const API_URL = "https://uy9nfxntoh.execute-api.us-west-2.amazonaws.com/PilotMode"

export const DarkModePrimaryColor = "#F5141F";
// Please turn off for no banner as "false"
export const showBanner = false;

